module.exports = __webpack_public_path__ + "img/fault-tracing--against-quine-duhem-cover.3d7e9cdd.jpg";